import React, { useCallback, useEffect, useState, useMemo } from "react";
import APIutil from "api/APIutils";
import * as url from "api/url";
import { useSelector, useDispatch } from "react-redux";
import { getAllResources } from 'action/cultureAction';
import { columnConfig } from "./constants";
import { TStatusDisplayId, FamilyType } from "components/common/constants";
// import { useLocation } from "react-router-dom";

export const useFetchEquipmentData = (buildingId = null, familyTypeId = null, urlSearchPath) => {
    const [state, setState] = useState({
        buildings: [],
        familyType: [],
        equipmentList: [],
        tableColumn: [],
        tableRowData: [],
        buildingLoader: false,
        familyTypeLoader: false,
        equipmentListLoader: false,
        error: "",
        dataPointsLoader: false,
        handlerId: null,
    });
    const [sortConfig, setSortConfig] = useState({ sortedColumnIndex: 0, sortOrder: "asc" });
    const { getLabel } = useGetLocalizationLabel();
    const query = useQuery(urlSearchPath);

    useEffect(() => {
        fetchBuildings();
        fetchFamilyTypes();
        // fetchEquipmentList(buildingId, familyTypeId);
    }, []);

    useEffect(() => {
        if (state.handlerId) {
            fetchDataPoints(state.handlerId);
        }
    }, [state.handlerId]);
    
    const onClickSort = useCallback((columnIndex, columnOrder) => {
        setSortConfig({ sortedColumnIndex: columnIndex, sortOrder: columnOrder ? "asc" : "desc" });
    }, []);

    const constructTableColumn = (familyTypeId) => {
        const configData = columnConfig[familyTypeId] && columnConfig[familyTypeId].length ? columnConfig[familyTypeId] : columnConfig[1];
        const updatedColumn = [];
        // Constructing table header columns
        configData.map((column, index) => {
            const labelText = getLabel(column.intlId, familyTypeId);
            updatedColumn.push({
                title: labelText ? labelText : column.title,
                onClick: (columnIndex, columnName, columnOrder) => { onClickSort(columnIndex, columnOrder, columnName); },
                intlId: column.intlId,
                type: column.type,
                label: labelText ? labelText : column.title,
                value: labelText ? labelText : column.title,
                columnIndex: index
            });
            return column;
        });
        return updatedColumn;
    }

    const checkMinMaxLimitReached = (stringValue) => {
        const HIGH_LIMIT = "3";
        const LOW_LIMIT = "4";
        if (stringValue.indexOf(".") > -1) {
            const prefixValue = stringValue.substring(0, stringValue.indexOf("."));
            return (prefixValue === HIGH_LIMIT || prefixValue === LOW_LIMIT)
        } else {
            return false;
        }
    }

    const getHtmlElementId = (rowData, columnData, familyTypeId) => {
        let columnId = columnData.intlId;
        if (rowData.isEvoObject && `${FamilyType.AirHandlers}` === familyTypeId && columnData.intlId === TStatusDisplayId.SupplyFanStatus) {
            columnId = TStatusDisplayId.SupplyFanSpeed;
        } else if (rowData.isEvoObject && `${FamilyType.Area}` === familyTypeId && columnData.intlId === TStatusDisplayId.InsideTemperature) {
            columnId = TStatusDisplayId.SpaceTemperatureSensor;
        } else if (rowData.panelInfoType === 100 && `${FamilyType.Chillers}` === familyTypeId && columnData.intlId === TStatusDisplayId.OperatingMode) {
            columnId = TStatusDisplayId.ActiveMode;
        } else if (rowData.isEvoObject && `${FamilyType.AirHandlers}` === familyTypeId && columnData.intlId === TStatusDisplayId.DuctStaticPressureStPt) {
            columnId = TStatusDisplayId.EvoDuctStaticPressureSpt;
        }
        if (rowData.isEvoObject && `${FamilyType.Chillers}` === familyTypeId && columnData.intlId === TStatusDisplayId.OperatingMode) {
            columnId = TStatusDisplayId.Status;
        }
        return `${rowData.id}-${columnId}`;
    }

    let fetchTimeout = null;
    const fetchBuildings = useCallback(() => {
        setState(prevState => ({ ...prevState, buildingLoader: true, error: "" }));
        APIutil.getDataAPI(`${url.getBuildings}`).then(response => {
            if (response && Array.isArray(response)) {
                let updatedResponse = [];
                updatedResponse = response.map(item => {
                    const svgIconFile = require('Assets/icons/FamilyNumber8.svg').default;
                    return {
                        ...item,
                        label: <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "center" }}>
                            <img style={{ width: "20px", height: "20px", marginRight: "11px" }} src={svgIconFile} alt="" />
                            <p>{item.name}</p>
                        </div>,
                        value: item.id,
                    }
                });
                setState(prevState => ({ ...prevState, buildingLoader: false, buildings: updatedResponse }));
            } else {
                const message = response && response.statusText ? response.statusText : "Unable to process the request.";
                setState(prevState => ({ ...prevState, buildingLoader: false, error: message }));
            }
        }).catch(error => {
            const errorMessage = error.message ? error.message : "Unable to process the request.";
            setState(prevState => ({ ...prevState, buildingLoader: false, error: errorMessage }));
        });
    }, [setState]);

    const fetchFamilyTypes = useCallback((buildingIdParam) => {
        let updatedBuildingId = buildingIdParam ? JSON.parse(JSON.stringify(buildingIdParam)) : JSON.parse(JSON.stringify(buildingId));
        if (!updatedBuildingId) {
            updatedBuildingId = query.get("buildingId");
        }
        setState(prevState => ({ ...prevState, familyTypeLoader: true, error: "" }));
        // '/api/buildings/{siteId}/family';
        APIutil.getDataAPI(`${url.getFamilyTypes}/${updatedBuildingId}/familyType`).then(response => {
            if (response && Array.isArray(response)) {
                let updatedResponse = [];
                updatedResponse = response.map(item => {
                    let svgIconFile = "";
                    try {
                        svgIconFile = require(`Assets/icons/FamilyNumber${item.familyId}.svg`).default;
                    } catch (error) {
                        svgIconFile = require('Assets/icons/FamilyNumber4.svg').default;
                    }
                    return {
                        ...item,
                        label: <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "center" }}>
                            <img style={{ width: "20px", height: "20px", marginRight: "11px" }} src={svgIconFile}
                                alt="" />
                            <p>{item.familyName}</p>
                        </div>,
                        value: item.familyId,
                    }
                });
                setSortConfig({ sortedColumnIndex: 0, sortOrder: "asc", sortedColumnName: "Name" });
                setState(prevState => ({ ...prevState, familyTypeLoader: false, familyType: updatedResponse }));
            } else {
                const message = response && response.statusText ? response.statusText : "Unable to process the request.";
                setState(prevState => ({ ...prevState, familyTypeLoader: false, familyType: [], tableRowData: [], error: message }));
            }
        }).catch(error => {
            const errorMessage = error.message ? error.message : "Unable to process the request.";
            setState(prevState => ({ ...prevState, familyTypeLoader: false, error: errorMessage, familyType: [], tableRowData: [] }));
        });
    }, [setState, query, buildingId]);

    const onClickNameUrl = (updatedBuildingId, rowDataid) => {
        window.location.href = encodeURI(`${window.location.origin}/tracerensemble/Status/EquipmentSummary.aspx?BuildingId=${updatedBuildingId}&EquipmentId=${rowDataid}`);
    }


    const fetchEquipmentList = useCallback((buildingIdParam, familyTypeIdParam) => {
        const tableColumn = constructTableColumn(familyTypeIdParam);
        let updatedBuildingId = JSON.parse(JSON.stringify(buildingIdParam));
        if (!updatedBuildingId) {
            updatedBuildingId = query.get("buildingId");
        }
        setState(prevState => ({ ...prevState, equipmentListLoader: true, error: "", tableColumn }));
        // '/api/buildings/{siteId}/family/{familyId}';
        APIutil.getDataAPI(`${url.getFamilyTypes}/${updatedBuildingId}/family/${familyTypeIdParam}/controllers`).then(response => {
            if (response && response.l_Collection && Array.isArray(response.l_Collection)) {
                const updatedResponse = [];
                response.l_Collection.map(rowData => {
                    const eachCellData = [];
                    // initial row data construction for table
                    tableColumn.map((item, index) => {
                        if (index === 0) {
                            eachCellData.push({
                                ...rowData,
                                title: rowData.objectName ? rowData.objectName :
                                    <div style={{ color: "#6890C6" }} onClick={() => onClickNameUrl(updatedBuildingId, rowData.id)} >
                                        <span style={{ cursor: "pointer" }}>{rowData.name}</span>
                                    </div>,
                                value: rowData.id,
                                htmlElementId: getHtmlElementId(rowData, item, familyTypeIdParam),
                                intlId: item.intlId,
                                label: rowData.objectName ? rowData.objectName : rowData.name,
                                displayText: rowData.objectName ? rowData.objectName : rowData.name
                            });
                        } else if ((`${familyTypeIdParam}` === `${FamilyType.Spaces}` || `${familyTypeIdParam}` === `${FamilyType.Meter}` || `${familyTypeIdParam}` === `${FamilyType.Plants}`) && index === 1) {
                            eachCellData.push({
                                ...rowData,
                                title: rowData.equipmentType ? rowData.equipmentType : "---",
                                value: rowData.id,
                                htmlElementId: getHtmlElementId(rowData, item, familyTypeIdParam),
                                intlId: item.intlId,
                                displayText: rowData.equipmentType ? rowData.equipmentType : "---",
                            });
                        } else {
                            eachCellData.push({
                                ...rowData,
                                title: "---",
                                value: `default_id_${index}`,
                                htmlElementId: getHtmlElementId(rowData, item, familyTypeIdParam),
                                intlId: item.intlId,
                                displayText: "---",
                            });
                        }
                        return item;
                    });
                    updatedResponse.push(eachCellData);
                    return rowData;
                });
                if (updatedResponse && updatedResponse.length) {
                    updatedResponse.unshift([]);
                }
                setState(prevState => ({ ...prevState, equipmentListLoader: false, equipmentList: response, tableRowData: updatedResponse, handlerId: response.l_ReadHandle }));
            } else {
                const message = response && response.statusText ? response.statusText : "Unable to process the request.";
                setState(prevState => ({ ...prevState, equipmentListLoader: false, equipmentList: [], tableRowData: [], error: message }));
            }
        }).catch(error => {
            const errorMessage = error.message ? error.message : "Unable to process the request.";
            setState(prevState => ({ ...prevState, equipmentListLoader: false, error: errorMessage, equipmentList: [], tableRowData: [] }));
        });
    }, [setState]);
  
   
    const fetchDataPoints = useCallback((handlerId) => {
        setState(prevState => ({ ...prevState, dataPointsLoader: true, error: "" }));
        APIutil.getDataAPI(`${url.getEquipmentsRowData}/${handlerId}`).then(response => {                                                                               

            if (response && response.dataPointValues && Array.isArray(response.dataPointValues) && state.tableRowData && state.tableRowData.length) {
                const updatedRowData = [...state.tableRowData];
                updatedRowData.map((rowData, rowIndex) => {
                    if (rowIndex !== 0) {
                        rowData.map(cellData => {
                            const dataPointObject = response.dataPointValues.find(pointItem => pointItem.htmlElementId === cellData.htmlElementId);
                            const elementState = response.dataPointValues.find(pointItem => pointItem.htmlElementId === `${cellData.id}-${cellData.intlId}_EventState`);
                            // console.log("...daa", dataPointObject, cellData.htmlElementId);
                            if (dataPointObject && dataPointObject.statusEnum !== "") {
                                const labelText = getLabel(`Enum${dataPointObject.statusEnum}.${dataPointObject.displayText}`);
                                if (elementState && checkMinMaxLimitReached(elementState.displayValue)) {
                                    cellData.title = <div style={{ color: "red", fontWeight: "600" }}>{labelText ? labelText : dataPointObject.displayText}</div>
                                } else {
                                    cellData.title = labelText ? labelText : dataPointObject.displayText;
                                }
                                cellData.displayText = labelText ? labelText : dataPointObject.displayText;
                            } else if (dataPointObject && dataPointObject.displayText) {
                                // const unitText = getLabel(`Enum3046.${dataPointObject.units}`);
                                if (elementState && checkMinMaxLimitReached(elementState.displayValue)) {
                                    cellData.title = <div style={{ color: "red", fontWeight: "600" }}>{dataPointObject.displayText} {dataPointObject.unitsText}</div>
                                } else {
                                    cellData.title = dataPointObject.displayText + " " + dataPointObject.unitsText;
                                }
                                cellData.displayText = dataPointObject.displayText;
                            }
                            return cellData;
                        });
                    }
                    return rowData;
                });
                let showLoader = false;
                if (!response.isComplete) {
                    showLoader = true;
                    fetchTimeout = setTimeout(() => {
                        fetchDataPoints(handlerId);
                    }, 500);
                } else {
                    clearTimeout(fetchTimeout);
                }
                setState(prevState => ({ ...prevState, dataPointsLoader: showLoader, tableRowData: updatedRowData }));
            } else {
                setState(prevState => ({ ...prevState, dataPointsLoader: false, }));
            }
        }).catch(error => {
            setState(prevState => ({ ...prevState, dataPointsLoader: false }));
        });


    }, [setState, state]);
    const fetchNewPoint=useCallback((requestData)=>{
        
        setState(prevState => ({ ...prevState, dataPointsLoader: true, error: "" }));
         APIutil.postData(url.getResponsePoint, requestData).then(response => {
          //displayID and ID 
          let responseVal = {};
          responseVal = response.data.l_Collection;
          const handlerId=response.data.l_ReadHandle;
          if (responseVal && responseVal.dataPointValues && Array.isArray(responseVal.dataPointValues) && state.tableRowData && state.tableRowData.length) {
            const updatedRowData = [...state.tableRowData];
            updatedRowData.map((rowData, rowIndex) => {
              if (rowIndex !== 0) {
                rowData.map(cellData => {
                  const dataPointObject = responseVal.dataPointValues.find(pointItem => pointItem.htmlElementId === cellData.htmlElementId);
                  const elementState = responseVal.dataPointValues.find(pointItem => pointItem.htmlElementId === `${cellData.id}-${cellData.intlId}_EventState`);
                  if (dataPointObject && dataPointObject.statusEnum !== "") {
                     const labelText = getLabel(`Enum${dataPointObject.statusEnum}.${dataPointObject.displayText}`);
                     if (elementState && checkMinMaxLimitReached(elementState.displayValue)) {
                       cellData.title = <div style={{ color: "red", fontWeight: "600" }}>{labelText ? labelText : dataPointObject.displayText}</div>
                     } else {
                       cellData.title = labelText ? labelText : dataPointObject.displayText;
                     }
                     cellData.displayText =  dataPointObject.displayText;//labelText ? labelText :
                  } else if (dataPointObject && dataPointObject.displayText) {
                     // const unitText = getLabel(`Enum3046.${dataPointObject.units}`);
                     if (elementState && checkMinMaxLimitReached(elementState.displayValue)) {
                       cellData.title = <div style={{ color: "red", fontWeight: "600" }}>{dataPointObject.displayText} {dataPointObject.unitsText}</div>
                     } else {
                       cellData.title = dataPointObject.displayText + " " + dataPointObject.unitsText;
                     }
                    cellData.displayText = dataPointObject.displayText;
                  }
                  return cellData;
                });
              }
              return rowData;
            });
            let showLoader = false;
             if (!responseVal.isComplete) {
               showLoader = true;
               fetchTimeout = setTimeout(() => {
                fetchDataPoints(handlerId);
               }, 500);
             } else {
               clearTimeout(fetchTimeout);
             }
             setState(prevState => ({ ...prevState, dataPointsLoader: showLoader, tableRowData: updatedRowData }));
           } else {
             setState(prevState => ({ ...prevState, dataPointsLoader: false, }));
           }
        }).catch(error => {
          const errorMessage = error.message ? error.message : "Unable to process the request.";
          setState(prevState => ({ ...prevState, loading: false, error: errorMessage }));
        });
    

    });
    return {
        buildings: state.buildings,
        familyType: state.familyType,
        equipmentList: state.equipmentList,
        tableColumn: state.tableColumn,
        tableRowData: state.tableRowData,
        buildingLoader: state.buildingLoader,
        familyTypeLoader: state.familyTypeLoader,
        equipmentListLoader: state.equipmentListLoader,
        error: state.error,
        refetchBuildings: fetchBuildings,
        refetchFamilyTypes: fetchFamilyTypes,
        refetchEquipmentList: fetchEquipmentList,
        updateApiData: setState,
        fetchDataPoints: fetchDataPoints,//return fetchdatapoint
        fetchNewPoint:fetchNewPoint,
        dataPointsLoader: state.dataPointsLoader,
        sortConfig
    };
}

 
export const useGetLocalizationLabel = () => {
    const dmResourceLabels = useSelector(state => state.CulturalLabelsRootReducer.DMResource_LabelsBasedOnPreference);
    const dispatch = useDispatch();

    useEffect(() => {
        if (dmResourceLabels["DISPID1.Text"] === undefined) {
            dispatch(getAllResources());
        }
    }, []);

    const getLabel = (labelKey, familyTypeId) => {
        if (`${familyTypeId}` === `${FamilyType["Chillers"]}` && labelKey === TStatusDisplayId["OperatingMode"]) {
            return dmResourceLabels["DISPID143.Text"] ? dmResourceLabels["DISPID143.Text"] : "Running Mode";
        } else if (`${familyTypeId}` === `${FamilyType["AirHandlers"]}` && labelKey === TStatusDisplayId["DischargeAirTempStPt"]) {
            return dmResourceLabels["FamilyGridDischargeAirTempstp.Text"] ? dmResourceLabels["FamilyGridDischargeAirTempstp.Text"] : "Discharge Air Temperature Setpoint";
        } else if (`${familyTypeId}` === `${FamilyType["VRF_Indoor"]}` && labelKey === TStatusDisplayId["SetPointType"]) {
            return dmResourceLabels["setPointType.Text"] ? dmResourceLabels["setPointType.Text"] : "Set Point Type";
        } else if (dmResourceLabels && dmResourceLabels[`${labelKey}.Text`]) {
            return dmResourceLabels[`${labelKey}.Text`];
        } else {
            return "";
        }
    }

    // const getAPIErrorLabels = (labelKey) => {
    //     if (dmResourceLabels && dmResourceLabels[`Enum.ApplicationError.${labelKey}.Text`]) {
    //         return dmResourceLabels[`Enum.ApplicationError.${labelKey}.Text`];
    //     } else {
    //         return "";
    //     }
    // }

    return {
        dmResourceLabels,
        getLabel,
        // getAPIErrorLabels
    }
}

export const useQuery = (search) => {
    // const { search } = useLocation();
    return useMemo(() => new URLSearchParams(search), [search]);
}
export const useFetchPointsData = (equipmentTypes = [], buildingId = null, familyTypeId = null, urlSearchPath) => {
    const [state, setState] = useState({
        pointsList: [],
        error: "",
        loading: false,
        selectAll: false,
        selectedRow: []//tablerowdata
    });
    const equipmentIds = [];
    const query = useQuery(urlSearchPath);
    useEffect(() => {
        fetchPoints(buildingId, familyTypeId);
    }, [equipmentTypes]);

    
    const fetchPoints = useCallback((buildingId, familyTypeId) => {
        //tablecolumn constructTableColumn
        
        let updatedBuildingId = JSON.parse(JSON.stringify(buildingId));
        let updatedFamiltyType = JSON.parse(JSON.stringify(familyTypeId));
        if (!updatedBuildingId) {
            updatedBuildingId = query.get("buildingId");
        }
        if (!updatedFamiltyType) {
            updatedFamiltyType = query.get("familyType");
        }
        setState(prevState => ({ ...prevState, loading: true, error: "" }));
        let maxLen=0;
        equipmentTypes.map((item, index) => {
            if (index !== 0) {
                equipmentIds.push(item[0].id);
                 maxLen=maxLen<item.length?item.length:maxLen;
            }
            return item;
        });
        APIutil.getDataAPI(`${url.getEquipmentDisplayId}/${updatedBuildingId}/${updatedFamiltyType}`)
            .then(response => {
                if (response) {

                    const updatedResponse = [];
                    response.buildingNames.map(pointItem => {
                        const pointValue = pointItem.objectByFamily.length > 0 ? pointItem.objectByFamily[0].dataProperties : null;
                        pointValue.map(pointValueData => {
                            updatedResponse.push({
                                label: pointValueData.name ? pointValueData.name : pointValueData.defaultName,
                                value: pointValueData.name ? pointValueData.name : pointValueData.defaultName,
                                title: pointValueData.name ? pointValueData.name : pointValueData.defaultName,
                                intlId: pointValueData.displayId,
                                siteId: updatedBuildingId,
                                columnIndex:maxLen,
                                ...pointValueData,
                                onClick: () => null
                                
                            });
                            return pointValueData;
                        });
                        return pointItem;
                    });
                    setState(prevState => ({ ...prevState, loading: false, error: "", pointsList: updatedResponse }));
                } else {
                    const message = response && response.statusText ? response.statusText : "Unable to process the request.";
                    setState(prevState => ({ ...prevState, loading: false, error: message }));
                }
            }).catch(error => {
                const errorMessage = error.message ? error.message : "Unable to process the request.";
                setState(prevState => ({ ...prevState, loading: false, error: errorMessage }));
            });
    }, [setState, equipmentTypes]);

    return {
        pointsList: state.pointsList,
        loading: state.loading,
        error: state.error,
        fetchPoints

    };
}